import "./PagePickerElement-style";

class SearchSummaryElement extends HTMLElement {
    constructor() {
        super();

        this.innerHTML = this.view();
    }

    private view = () => `
        <tag-button selected>Elton</tag-button><tag-button selected>John</tag-button>
    `;
}

customElements.define("search-summary", SearchSummaryElement);